import { filter, findIndex } from "lodash";
import { TechProfilesListAction, TechProfilesListActions } from "./tech-profiles-list-actions";

const INITIAL_STATE: TechProfileState = {
    originalClientTechProfiles: [],
    clientTechProfiles: [],
    appliesToFilters: [],
    activeTechProfileIdForAttachments: -1,
};

interface TechProfileState {
    appliesToFilters: any[]
    clientTechProfiles: any[]
    originalClientTechProfiles: any[]
    activeTechProfileIdForAttachments: number
}

export function clientTechProfilesReducer(state: TechProfileState = INITIAL_STATE, action: TechProfilesListAction) {
    switch (action.type) {

        case TechProfilesListActions.GET_TECH_PROFILES_LIST_SUCCESS:
            return {...state, clientTechProfiles: action.payload, originalClientTechProfiles: action.payload};

        case TechProfilesListActions.GET_TECH_PROFILES_APPLIES_TO_LIST_SUCCESS:
            const appliesToFilters: any[] = [];

            Array.from(Object.keys(action.payload),
                (k) => action.payload[k]).forEach((item) => {
                appliesToFilters.push({value: item.id, label: item.name, state: false})
            });

            return {...state, appliesToFilters};

        case TechProfilesListActions.TOGGLE_APPLIES_TO:
            const matchedIndex = findIndex(state.appliesToFilters, {value: (action.payload as any).value});

            const filtersToArray: typeof state.appliesToFilters = Object.assign([], state.appliesToFilters);
            filtersToArray[matchedIndex].state = !filtersToArray[matchedIndex].state;

            let clientTechProfilesArray: typeof state.originalClientTechProfiles = Object.assign([], state.originalClientTechProfiles);
            if (findIndex(filtersToArray, {state: true} as any) >= 0) {
                clientTechProfilesArray = filter(clientTechProfilesArray, (item: any) => {
                    return findIndex(filtersToArray, {label: item.appliesTo, state: true} as any) >= 0
                });
            }
            return Object.assign({}, state, {appliesToFilters: filtersToArray, clientTechProfiles: clientTechProfilesArray});

        case "commonForms::FORM_CLOSED":
            return {...state, activeTechProfileIdForAttachments: -1};

        case TechProfilesListActions.SET_ATTACHMENTS_VISIBLE:
            return {...state, activeTechProfileIdForAttachments: action.payload};

        case TechProfilesListActions.CLEAR_APPLIES_TO:
            const currentAppliesTo: typeof state.appliesToFilters = Object.assign([], state.appliesToFilters);
            currentAppliesTo.forEach((thing) => thing.state = false);
            return {...state, appliesToFilters: currentAppliesTo, clientTechProfiles: state.originalClientTechProfiles};

        default:
            return state;
    }
}
